export enum EditorType {
    FORWARDMAIL = 1,
    NEWMAIL = 2,
}
